import React from "react";
import Box from "../Box";
import { isColumnsAllowed } from "./Stack-styles";

interface PropsType {
  children?: React.ReactNode;
  columns: string[];
  fillIfEmpty?: boolean;
  // not implemented. don't use please
  gap?: number;
}

function Columns(props: PropsType) {
  if (!isColumnsAllowed(props)) {
    return props.children;
  }

  function boxForEmptySpaces(numberOfColumns: number, numberOfItems: number) {
    let divideRemaining = numberOfItems % numberOfColumns;
    let extraBox = numberOfColumns - divideRemaining;
    let boxes: string[] = [];
    if (numberOfColumns !== extraBox) {
      boxes = new Array(extraBox).fill("box");
    }
    let boxWidth = `${90 / numberOfColumns}%`;
    return boxes.map(() => {
      return <Box style={{ width: boxWidth, height: 100 }} />;
    });
  }

  return (
    <>
      {React.Children.map(props.children, (item, index) => {
        let column_idx = index > 0 ? index % props.columns.length : 0;
        let isFirstChild = index % props.columns.length === 0;
        let isLastChild =
          index % props.columns.length === props.columns.length - 1;
        let gap = props.gap ? props.gap / 2 : 0;
        let margin_right = isFirstChild ? 0 : gap;
        let margin_left = isLastChild ? 0 : gap;
        return (
          <Box
            style={{
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: props.columns[column_idx],
              marginRight: margin_right,
              marginLeft: margin_left,
            }}
          >
            {item}
          </Box>
        );
      })}
      {props.fillIfEmpty
        ? boxForEmptySpaces(props.columns.length, props.children.length)
        : null}
    </>
  );
}

export default Columns;
